import { type PimProductV11 } from '@redteclab/api/clients/bully'

export const PRODUCT_ACTIVE_SUBSTANCE_TYPE = {
  HYDROCORTISON: 'hydrocortison',
  METHOTREXAT: 'methotrexat',
}

export const productAccessorGetProductActiveSubstanceType = (
  product: PimProductV11,
): string | null => {
  const atcName = product.atc?.name.trim().toLowerCase()

  if (
    atcName === PRODUCT_ACTIVE_SUBSTANCE_TYPE.METHOTREXAT ||
    atcName === PRODUCT_ACTIVE_SUBSTANCE_TYPE.HYDROCORTISON
  ) {
    return atcName
  }

  return null
}
